import store from './index';
export const selectMetroMap = () => store((state) => state.map);
export default {
    getMetro: store.getState().getMetro,
    setSelected: store.getState().setSelected,
};
